import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgForm, FormControl } from '@angular/forms';
import { UserService } from '../services/user.service';
import { User } from 'models/user.model';

import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { ModalForgotPasswordComponent } from '../modal-forgot-password/modal-forgot-password.component';
import { TooltipPosition } from '@angular/material';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.css'
  ]
})
export class LoginComponent implements OnInit {

  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective

  user: User;
  selectedFile: File;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  passwordPattern = "^[A-Z][a-z]{7,}";
  formPattern = "[A-Za-z]{1,}";
  modalReference = null;
  profileImage: any = require("../image/profile.jpg");
  logoImage: any = require("../image/logo/Amodto.jpg")

  positionOptions: TooltipPosition[] = ['right'];
  position = new FormControl(this.positionOptions[0]);

  isSendRequest = false;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private translate: TranslateService,
    private userService: UserService,
    private toastr: ToastrService,
    private config: NgbDropdownConfig
  ) {
    translate.addLangs(['gb', 'it']);
    translate.setDefaultLang('it');

    var browserLang = translate.getBrowserLang();
    var local = localStorage.getItem('localLanguage');
    translate.use((local && local.match(/gb|it/)) ? local : (browserLang.match(/gb|it/) ? browserLang : 'it'));
  }


  ngOnInit() {
    this.resetForm();
    this.toastr.overlayContainer = this.toastContainer;
    localStorage.setItem('localLanguage', this.translate.currentLang);
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    localStorage.setItem('localLanguage', language);
  }

  openLg(content) {
    this.modalReference = this.modalService.open(content, { size: 'lg' });
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0]
  }

  onUpload() {
    // upload code for photo
  }

  openForgotModal(content) {
    this.modalService.open(ModalForgotPasswordComponent, { centered: true });
  }

  //Reset Form Register User
  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.user = {
      id: 0,
      Email: '',
      Username: '',
      Password: '',
      Name: '',
      LastName: '',
      Phone: '',
      HasAcceptedTerms: false
    }
  }

  //Register User API
  OnSubmit(form: NgForm) {
    //Call Api of User service used to register user.
    this.userService.registerUser(form.value)
      .subscribe(
        data => {
          this.resetForm(form)
          this.translate.get('STATUS_CODE_200.TITLE').subscribe((res: string) => {
            this.toastr.success(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            })
          });
          this.modalReference.close();
        },
        error => {
          if (error.status == 302) {
            this.translate.get('STATUS_CODE_302.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
            });

          } else if (error.status == 400) {
            this.translate.get('STATUS_CODE_400.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
            });

          } else {
            this.router.navigate(['/errorPage'])
          }
          throw error;
        });
  }

  //Login User API
  LoginSubmit(username, password) {
    //Call Api user service for logged user and save in LocalStorage token, expires, username.
    this.isSendRequest = true;
    this.userService.userAuthentication(username, password)
      .subscribe(data => {
        this.isSendRequest = false;
        this.router.navigate(['/home']);
      },
        error => {
          this.isSendRequest = false;
          if (error.status == 400) {
            this.toastr.error(error.error.error_description, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            })
          } else {
            this.router.navigate(['/errorPage']);
          }
        });
  }
}


